/* this file is transformed by vux-loader */
/* eslint-disable */
/* this file is transformed by vux-loader */

/* eslint-disable */

/*
 * @Description:
 * @Author: 王佳兴
 * @Github:
 * @Date: 2018-12-21 17:02:06
 * @LastEditors: 王佳兴
 * @LastEditTime: 2019-01-04 13:31:13
 */

/**
 * Created by WJX on 2017/11/22.
 */
import { courseReport, getChannelById } from '@/api/ajax.js';
export var contentview = {
  data: function data() {
    return {
      play_time: 0,
      // 初始看课播放时间 分钟单位
      pageStayTimeInter: null,
      // 定时器 页面停留
      sendReportInter: null,
      // 看课定时器
      pageStayTimeSub: 1,
      // 上报停留时间 秒
      zone_name: '',
      // 专区名
      zone_id: '' // 专区ID

    };
  },
  methods: {
    // 点击播放后事件
    videoPlay: function videoPlay(courseType, fn) {
      var _this = this; // 点击播放后上报
      // TODO: 业务逻辑处理 并不是真实的点击播放后上报 而是进入就开始定时上报
      // this.$refs.video.addEventListener('play', () => {


      fn && fn();

      if (!this.sendReportInter) {
        this.sendReport(courseType);
        this.sendReportInter = setInterval(function () {
          // 如果是落地页 没有用户信息，后端报错
          if (!/liveShare|courseShare/.test(_this.$route.name)) {
            courseReport({
              courseId: _this.$route.params.id
            });
          }

          _this.play_time += 1;
          _this.pageStayTimeSub += 60;

          _this.sendReport(courseType);
        }, 60 * 1000);
      } // })
      // this.$refs.video.addEventListener('pause', function() {
      //   alert('暂停')
      // })
      // this.$refs.video.addEventListener('ended',function (){
      //   alert('播放结束')
      // })

    },
    // 上报消费
    pageStayTime: function pageStayTime(courseType, fn) {
      var _this2 = this;

      var contentview = function contentview(courseType, fn) {
        _this2.$sa.re_contentview({
          type: courseType,
          // 消费类型 直播，录播，资讯，病例，看课时长上报
          name: _this2.detailObj.courseName || _this2.detailObj.title || '',
          // 内容名字
          // release_dt:this.detailObj.liveStartTime || (this.detailObj.information && this.detailObj.information.releaseTime) || '', // 直播时间/发布时间 直播是直播时间，录播是发布时间，资讯、病例是发布时间
          contentid: _this2.$route.params.id + '',
          // 内容id
          // TODO: 暂时注释
          // first_cate: this.categoriesArr[0].categoryName, //一级分类
          // second_cate: this.categoriesArr[1].categoryName, // 2级分类
          // first_cate_id: this.categoriesArr[0].id, // 1级分类id
          // second_cate_id: this.categoriesArr[1].id, //2级分类id
          author: _this2.detailObj.editorName || '',
          // 讲师/作者
          source_user_id: _this2.$route.query.source_user_id || '',
          // 分享人老ID
          zone_name: _this2.zone_name || '',
          // 专区
          zone_id: _this2.zone_id || '' // 专区
          // location: '', //位置 站内，专区内，超级面对面内
          // pageStayTime:this.pageStayTimeSub // 停留时间

        });

        if (fn) {
          fn();

          if (!_this2.pageStayTimeInter) {
            // 上报停留时间
            _this2.pageStayTimeInter = setInterval(function () {
              // this.$sa.re_contentview({
              //   type: courseType, // 消费类型 直播，，资讯，病例，看课时长上报
              //   name:this.detailObj.courseName || this.detailObj.title || '', // 内容名字
              //   release_dt: '', // 直播时间/发布时间 直播是直播时间，录播是发布时间，资讯、病例是发布时间
              //   contentid: this.$route.params.id, // 内容id
              //   first_cate: '', //一级分类
              //   second_cate: '', // 2级分类
              //   first_cate_id: '', // 1级分类id
              //   second_cate_id: '', //2级分类id
              //   author: this.detailObj.editor, //讲师/作者
              //   location: '', //位置 站内，专区内，超级面对面内
              //   pageStayTime: new Date().getTime() // 停留时间
              // })
              fn && fn();
            }, 60 * 1000);
          }
        }
      }; // 如果有zoneid 没有 zonename 则拉去


      if (this.zone_id && !this.zone_name) {
        getChannelById({
          channelId: this.zone_id
        }).then(function (res) {
          _this2.zone_name = res.data.data;
          contentview(courseType, fn);
        });
      } else {
        contentview(courseType, fn);
      }
    },
    // 看课上报
    sendReport: function sendReport(courseType) {
      sa.track('course_report', {
        pageUrl: location.href,
        course_id: this.$route.params.id,
        course_name: this.detailObj.courseName,
        course_type: courseType == '录播' ? 'video' : 'live',
        from: this.scType,
        chapter_name: this.detailObj.courseName,
        web_edition: 2
      }); // 新版 看课时长 专区的只添加了专区ID

      this.$sa.re_contentview({
        type: courseType + '-看课时长',
        // 消费类型 直播，，资讯，病例，看课时长上报
        name: this.detailObj.courseName,
        // 内容名字
        // release_dt:this.detailObj.liveStartTime || (this.detailObj.information && this.detailObj.information.releaseTime) || '', // 直播时间/发布时间 直播是直播时间，录播是发布时间，资讯、病例是发布时间
        contentid: this.$route.params.id + '',
        // 内容id
        // first_cate: this.categoriesArr[0].categoryName, //一级分类
        // second_cate: this.categoriesArr[1].categoryName, // 2级分类
        // first_cate_id: this.categoriesArr[0].id, // 1级分类id
        // second_cate_id: this.categoriesArr[1].id, //2级分类id
        author: this.detailObj.editor || '',
        // 讲师/作者
        // location: '', //位置 站内，专区内，超级面对面内
        pageStayTime: this.pageStayTimeSub,
        // 停留时间
        play_time: this.play_time,
        source_user_id: this.$route.query.source_user_id || '' // 分享人老ID

      });
    }
  },
  created: function created() {
    this.zone_id = this.$route.query.zone_id;
  },
  beforeDestroy: function beforeDestroy() {
    if (this.sendReportInter) {
      clearInterval(this.sendReportInter);
    }

    if (this.pageStayTimeInter) {
      clearInterval(this.pageStayTimeInter);
    }

    try {
      this.$refs.video.removeEventListener('play', false);
    } catch (e) {}
  }
};